import { IList, IRecord } from 'annotation-tools/utils';
import {
  APIRawValidationErrorType,
  APIValidationErrorType,
  IAPIValidationErrorType
} from '../common/validation-error';
import {
  CsvAPIRawRequestBodyType,
  CsvAPIRequestBodyType
} from './api-request-body';


export type CsvAPIRawSuccessResponseType = {
  id: number;
  name: string; // [1..20] character
};

export type CsvAPIRawValidationErrorType = APIRawValidationErrorType<
  CsvAPIRawRequestBodyType
>;

export type CsvAPIValidationErrorType = APIValidationErrorType<
  CsvAPIRequestBodyType
>;

export type ICsvAPIValidationErrorType = IAPIValidationErrorType<
  CsvAPIRequestBodyType
>;

export const ICsvAPIValidationErrorFactory = IRecord<
  CsvAPIValidationErrorType
>({
  name: IList<string>()
});
